// 模型type 0 市电 1 光伏 2 自来水 3 中水 4 二氧化碳 5天然气 6 液氧 7 液氩 8 压缩空气 9 空压站自来水用量 10 空压站高压用电量 11 空压站低压用电量 12 蒸汽

export const config = [
  {
    title: '用电模块',
    children: [
      {
        label: '市电',
        type: 0,
        unit: 'kWh',
      },
      {
        label: '光伏',
        type: 1,
        unit: 'kWh',
      },
    ],
  },
  {
    title: '用水模块',
    children: [
      {
        label: '自来水',
        type: 2,
        unit: 'm³',
      },
      {
        label: '中水',
        type: 3,
        unit: 'm³',
      },
    ],
  },
  {
    title: '用气模块',
    children: [
      {
        label: '二氧化碳',
        type: 4,
        unit: 't',
      },
      {
        label: '天然气',
        type: 5,
        unit: 'm³',
      },
      {
        label: '液氧',
        type: 6,
        unit: 't',
      },
      {
        label: '液氩',
        type: 7,
        unit: 't',
      },
      {
        label: '压缩空气',
        type: 8,
        unit: 'm³',
      },
      {
        label: '空压站自来水用量',
        type: 9,
        unit: 'm³',
      },
      {
        label: '空压站高压用电量',
        type: 10,
        unit: 'kWh',
      },
      {
        label: '空压站低压用电量',
        type: 11,
        unit: 'kWh',
      },
    ],
  },
  {
    title: '蒸汽模块',
    children: [
      {
        label: '蒸汽',
        type: 12,
        unit: 't',
      },
    ],
  },
];
